export default __webpack_public_path__ + "static/media/information.92cb31d9.svg";